import * as React from 'react';
import { PromoBox } from '../../common/components/PromoBox';
import PropTypes from 'prop-types';
import { SvgCalendarIcons } from '../../calendars/components/SvgCalendarIcons';
import { PriceSection } from '../../common/components/PriceSection';
import { PrimaryButton, TertiaryLink } from "@sfly/uig-button";

export class CalendarsMarqueeSidePanel extends React.Component {

    constructor(props, state) {
        super(props, state);
        this.node_12X12 = React.createRef();
        this.node_8X11 = React.createRef();
        this.state = {
            cal_8x11_selected: false,
            cal_12x12_selected: true
        };
    }

    handleSizeChange(event, sizeId) {
        event.stopPropagation();

        if(sizeId === '12x12') {
            this.setState({
                cal_8x11_selected: false,
                cal_12x12_selected: true
            });
            this.node_12X12.current.classList.add('selected');
            this.node_8X11.current.classList.remove('selected');
            this.node_12X12.current.children[0].checked = true;
            this.node_12X12.current.children[0].focus();
        } else if(sizeId === '8x11') {
            this.setState({
                cal_8x11_selected: true,
                cal_12x12_selected: false
            });
            this.node_8X11.current.classList.add('selected');
            this.node_12X12.current.classList.remove('selected');
            this.node_8X11.current.children[0].checked = true;
            this.node_8X11.current.children[0].focus();
        }
    }

    handleCTAButtonClick(event, ctaTemplateLink) {
        event.preventDefault();

        // add variable size to usable for the string template ctaLink
        const size = document.getElementsByClassName('calendar-size selected')[0].children[0].value;

        // only used for the old calendar style store
        // can remove this code after all calendars_marquee_side_panel_cs content spaces have been updated
        // to point to responsive thumbnail
        document.cookie = `sizeId=${document.getElementsByClassName('calendar-size selected')[0].children[0].value}`;

        const ctaLink = ctaTemplateLink
                            .replace('${size}', size);

        window.location.href = ctaLink;
    }

    renderCalendarAssetOnSizes(sizeId) {
        const isSelect = this.state[`cal_${sizeId}_selected`];

        return (
            <div className="size-image" onClick={event => this.handleSizeChange(event, sizeId)}>
                <SvgCalendarIcons sizeId={sizeId} assetSize={'Large'} isSelected={isSelect} className="hideLargeAsset" />
                <SvgCalendarIcons sizeId={sizeId} assetSize={'Small'} isSelected={isSelect} className="hideSmallAsset" />
            </div>
        );
    }

    renderCalendarSizes(calendarSizeDetails) {
        if (!calendarSizeDetails || calendarSizeDetails.length < 1) { return null; }

        return (
            <div id="calendarSizes" className="form-size-section">
                {
                    calendarSizeDetails.map((calendarSize, index) => (
                        <div key={`size${calendarSize}`} id={`size${calendarSize}`} ref={calendarSize === '12x12' ? this.node_12X12 : this.node_8X11} className={`calendar-size${index === 0 ? ' selected' : ''}`}>
                            <input type="radio" name="sizeId" aria-label={`Size ${calendarSize}`} value={calendarSize} id={`size_${calendarSize}`} onClick={event => this.handleSizeChange(event, calendarSize)} defaultChecked={index === 0} aria-describedby={`price-section-${calendarSize}`}/>
                            <div className="size-details">
                                {this.renderCalendarAssetOnSizes(calendarSize)}
                                {this.props.pricingDetails && this.props.pricingDetails.length > 0 ? <PriceSection contentId={calendarSize} pricingDetails={this.props.pricingDetails} />
                                    : null}
                            </div>
                        </div>
                    ))
                }
            </div>
        );
    }

    getTrimmedTextIfContainsGTSign(text) {
        return text && text.indexOf('>') !== -1 ? text.replace('>', '') : '';
    }

    render() {
        const { promoDetails, marqueeSidePanelDetails } = this.props;
        const { cal_8x11_selected } = this.state;
        const trimmedLearnMoreText = this.getTrimmedTextIfContainsGTSign(
          marqueeSidePanelDetails.learnMore &&
            marqueeSidePanelDetails.learnMore.text
        );

        return(
            <div className={'side-panel'}>
                <PromoBox promoBoxDetails={promoDetails} />
                <div className={'h-line hide-on-mobile'} />
                <div
                    className={"action-zone hide-on-mobile"}
                    id="walCalForm"
                >
                    <h2 className="section-heading">{marqueeSidePanelDetails.heading}</h2>
                    <div className="section-sub-heading">{marqueeSidePanelDetails.subHeading}</div>
                    <div className="heading-heavy">{marqueeSidePanelDetails.chooseSizeLable}</div>

                    {this.renderCalendarSizes(marqueeSidePanelDetails.calendarSizeDetails)}

                    { marqueeSidePanelDetails.ctaSection ?
                        <div id="wallCalBtn">
                            <PrimaryButton
                                tabIndex={0}
                                aria-label={`${marqueeSidePanelDetails.ctaSection.text} of ${cal_8x11_selected ? '8x11' : '12x12'} size`}
                                onClick={event =>
                                    this.handleCTAButtonClick(
                                        event,
                                        marqueeSidePanelDetails.ctaSection.link
                                    )
                                }
                            >
                                {marqueeSidePanelDetails.ctaSection.text}
                            </PrimaryButton>
                        </div> : null}
                    { marqueeSidePanelDetails.learnMore ?
                        <div className="learn-more">
                            <span id="learnMoreLable">{marqueeSidePanelDetails.learnMore.lable}</span>&nbsp;
                            <TertiaryLink
                                href={marqueeSidePanelDetails.learnMore.link}
                                className={trimmedLearnMoreText ? 'gtSign' : ''}
                                aria-describedBy="learnMoreLable"
                                aria-label={trimmedLearnMoreText}
                            >
                                {trimmedLearnMoreText || marqueeSidePanelDetails.learnMore.text}
                            </TertiaryLink>
                        </div> : null}
                </div>
            </div>
        );
    }
}

CalendarsMarqueeSidePanel.propTypes = {
    promoDetails: PropTypes.object,
    marqueeSidePanelDetails: PropTypes.object.isRequired,
    pricingDetails: PropTypes.array
};

CalendarsMarqueeSidePanel.defaultProps = {
    promoDetails: undefined,
    pricingDetails: []
};

